const ProgramName = "Transition Track";
const ProgramCode = "TRANSITION";

export { ProgramCode, ProgramName };
